import React from 'react';
import isString from 'lodash/isString';

export const validateEmail = (email) => {
    // eslint-disable-next-line
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
};

export const filterObject = (object, func) =>
    Object.keys(object)
        .filter((key) => func(key))
        .reduce((obj, key) => {
            obj[key] = object[key]; // eslint-disable-line
            return obj;
        }, {});

export const getDate = (date = null) => {
    if (date === null) {
        return null;
    }
    const dateObject = isString(date) ? new Date(date) : date;
    return `${dateObject.getFullYear()}-${dateObject.getMonth()}-${dateObject.getDate()}`;
};

export const getFormatValues = () => ({
    strong: (msg) => React.createElement('strong', {}, msg),
    break: React.createElement('br'),
    nbsp: React.createElement('span', { dangerouslySetInnerHTML: { __html: '&nbsp;' } }),
});

export const isTouchDevice = () =>
    !!(
        typeof window !== 'undefined' &&
        ('ontouchstart' in window ||
            (window.DocumentTouch &&
                typeof document !== 'undefined' &&
                document instanceof window.DocumentTouch))
    ) ||
    !!(
        typeof navigator !== 'undefined' &&
        (navigator.maxTouchPoints || navigator.msMaxTouchPoints)
    );

export const getAbsoluteUrl = (url) => {
    if (url === null) {
        return null;
    }
    return url.match(/^\/([^/].*)?$/) !== null
        ? `${window.location.protocol}//${window.location.host}${url}`
        : url;
};

export const fallbackCopyTextToClipboard = (text, onSuccess = null, onError = null) => {
    const textArea = document.createElement('textarea');
    textArea.value = text;

    // Avoid scrolling to bottom
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    let success = false;
    try {
        success = document.execCommand('copy');
    } catch (err) {
        // console.error('Fallback: unable to copy', err);
    }

    document.body.removeChild(textArea);

    if (success && onSuccess !== null) {
        onSuccess();
    } else if (onError !== null) {
        onError();
    }
};

export const copyTextToClipboard = (text, onSuccess = null, onError = null) => {
    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text, onSuccess, onError);
        return;
    }
    navigator.clipboard.writeText(text).then(
        () => {
            if (onSuccess !== null) {
                onSuccess();
            }
        },
        (err) => {
            if (onError !== null) {
                onError(err);
            }
        },
    );
};
